<template>
	<div class="aside">
		<div class="logo">报名中心</div>
		<el-menu unique-opened :default-active="$route.path" router active-text-color="#2461ED" text-color="#909090" :default-openeds="['/' + $route.path.split('/')[1]]">
			<template v-for="(menu, i) in menus">
				<el-submenu v-if="menu.children" :index="menu.path">
					<template slot="title">
						<i class="left-bg"></i>
						<i :class="menu.icon"></i>
						<span>{{ menu.title }}</span>
					</template>
					<el-menu-item v-for="(item, index) in menu.children" :index="item.path">
						<span slot="title">{{ item.title }}</span>
					</el-menu-item>
				</el-submenu>
				<el-menu-item v-else :index="menu.path">
					<i class="left-bg"></i>
					<i :class="menu.icon"></i>
					<span slot="title">{{ menu.title }}</span>
				</el-menu-item>
			</template>
		</el-menu>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { reqGetUserInfo } from '@/api';
export default {
	data() {
		return {
			menus: [],
			list: [
				{
					title: '报名填表',
					icon: 'el-icon-edit-outline',
					path: '/form'
				},
				/*{
					title: '详细信息',
					icon: 'el-icon-document',
					path: '/info'
				},*/
				/*{
					title: '打印报名信息',
					icon: 'el-icon-printer',
					path: '/print-info'
				},*/
				/*{
					title: '报名统计',
					icon: 'el-icon-data-analysis',
					path: '/sign-up'
				},*/
				{
					title: '信息维护',
					icon: 'el-icon-user',
					path: '/info-maintain'
				},
				{
					title: '照片维护',
					icon: 'el-icon-picture-outline',
					path: '/photo'
				},
				{
					title: '网上缴费',
					icon: 'el-icon-coin',
					path: '/pay'
				},
				{
					title: '参考确认',
					icon: 'el-icon-coin',
					path: '/confirm'
				},
				{
					title: '申请退费',
					icon: 'el-icon-coin',
					path: '/refund'
				},
				/*{
					title: '打印准考证',
					icon: 'el-icon-printer',
					path: '/admission'
				},*/
				{
					title: '打印面试通知书',
					icon: 'el-icon-printer',
					path: '/interview'
				},
				{
					title: '成绩查询',
					icon: 'el-icon-search',
					path: '/query'
				},
				{
					title: '退出系统',
					icon: 'el-icon-switch-button',
					path: `/`
				}
			]
		};
	},
	computed: {
		...mapState({
			regist_start_time: state => state.system.examInfo.regist_start_time,
			regist_end_time: state => state.system.examInfo.regist_end_time,
			verify_time: state => state.system.examInfo.verify_time,
			pay_time: state => state.system.examInfo.pay_time,
			query_start_time: state => state.system.examInfo.query_start_time,
			query_end_time: state => state.system.examInfo.query_end_time,
			print_start_time: state => state.system.examInfo.print_start_time,
			print_end_time: state => state.system.examInfo.print_end_time,
			interview_start_time: state => state.system.examInfo.interview_start_time,
			interview_end_time: state => state.system.examInfo.interview_end_time,
			rc_start_time: state => state.system.examInfo.rc_start_time,
			rc_end_time: state => state.system.examInfo.rc_end_time,
			unitCode: state => state.system.unitCode,
			payment: state => state.system.payment,
			time_out: state => state.system.time_out,
			is_interview: state => state.user.examinee.is_interview,
			verify: state => state.user.examinee.verify,
			is_pay: state => state.user.examinee.is_pay,
			do_travel: state => state.user.examinee.do_travel,
			id: state => state.user.examinee.id
		}),
		...mapGetters('user',['GET_USER_INFO']),
		//是否可以报名
		isRegist() {
			return (
				new Date().getTime() < new Date(this.regist_end_time.replace(/\s/, 'T')).getTime()
			);
		},
		// 是否可以审核
		isVerify() {
			return new Date().getTime() < new Date(this.verify_time.replace(/\s/, 'T')).getTime();
		},
		// 是否可以缴费
		isPay() {
			return new Date().getTime() < new Date(this.pay_time.replace(/\s/, 'T')).getTime();
		},
		//否可以申请退费
		isRefund() {
			return (
				new Date().getTime() < new Date(this.rc_end_time.replace(/\s/, 'T')).getTime() &&
				new Date().getTime() > new Date(this.rc_start_time.replace(/\s/, 'T')).getTime() && (this.is_pay === 2 || this.is_pay === 5)
			);
		},
		// 是否可以参考确认
		isConfirm() {
			return (
				new Date().getTime() < new Date(this.rc_end_time.replace(/\s/, 'T')).getTime() &&
				new Date().getTime() > new Date(this.rc_start_time.replace(/\s/, 'T')).getTime() && (this.is_pay == 3 || this.is_pay === 4)
			);
		},
		// 是否可以打印面试
		isInterview() {
			return (
				new Date().getTime() < new Date(this.interview_end_time.replace(/\s/, 'T')).getTime() &&
				new Date().getTime() > new Date(this.interview_start_time.replace(/\s/, 'T')).getTime()
			) && this.is_interview === 1;
		},
		// 是否可以查询
		isQuery() {
			return (
				new Date().getTime() < new Date(this.query_end_time.replace(/\s/, 'T')).getTime() &&
				new Date().getTime() > new Date(this.query_start_time.replace(/\s/, 'T')).getTime()
			);
		},
		// 是否可以缴费
		isAfterPay() {
			return new Date().getTime() > new Date(this.pay_time.replace(/\s/, 'T')).getTime();
		},
		unit() {
			return sessionStorage.getItem('unit');
		},
		test() {
			return sessionStorage.getItem('unit');
		}
	},
	watch: {
		$route: {
			async handler() {
				if (this.$store.state.system.sign_up) {
					clearTimeout(this.$store.state.system.sign_up);
				}
				if (this.$store.state.user.addFormNum !== 1) { // 1 表示新增
					let _this = this;
					let ttl = 15 * 60 * 1000;
					if (this.is_pay != 1) {
						ttl = 5 * 60 * 1000;
					}
					let timerId = setTimeout(function() {
						_this.$store.commit('user/SET_EXAMINEE', {});
						_this.$router.push(`/${_this.unitCode}`);
					}, ttl);
					this.$store.commit('system/SET_SIGN_UP', timerId);
				   await this.$store.dispatch('user/setUserInfo');
				   await this.getUserInfo();
				} else {
				   await this.getUserInfo();
				}
			},
			immediate: true
		}
	},
	methods: {
		async getUserInfo() {
			console.log(":"+this.GET_USER_INFO.id);
			console.log(":"+this.id);
		      if (this.GET_USER_INFO.id === undefined) {
				if (this.id) {
					if(this.time_out && this.time_out < new Date()/1000) {
						this.$store.commit('user/SET_EXAMINEE', {});
						this.$router.push(`/${this.unitCode}`);
					} else {
						await reqGetUserInfo().then(res => {
							if(!this.isAfterPay) {
								let time_out = new Date().getTime()/1000 + 60 * 15;
								this.$store.commit('system/SET_TIME_OUT', time_out);
							}
							this.$store.commit('user/SET_EXAMINEE', {
								...res.data,
							});
							sessionStorage.setItem('path', res.data.name+""+res.data.card_id);
						});
					}
					if (this.payment && (this.payment.alipay_app_id || this.payment.wechat_app_id || this.payment.yeepay_app_id)) {
						if (this.verify === 3) {
							this.getMenus(true, false);
						} else {
							this.getMenus(false, true);
						}
					} else if (this.verify === 3) {
						this.getMenus(false, false);
					} else {
						this.getMenus(false, true);
					}
				} else {
					this.getMenus(false);
				}
		      } else {
				if (this.id) {
					  if(this.time_out && this.time_out < new Date()/1000) {
						    this.$store.commit('user/SET_EXAMINEE', {});
						    this.$router.push(`/${this.unitCode}`);
					  } else {
						    if(!this.isAfterPay) {
						      let time_out = new Date().getTime()/1000 + 60 * 15;
						      this.$store.commit('system/SET_TIME_OUT', time_out);
						    }
						    this.$store.commit('user/SET_EXAMINEE', {
						      ...this.GET_USER_INFO,
						    });
						    sessionStorage.setItem('path', this.GET_USER_INFO.name+""+this.GET_USER_INFO.card_id);
					  }
					  if (this.payment && (this.payment.alipay_app_id || this.payment.wechat_app_id || this.payment.yeepay_app_id)) {
						    if (this.verify === 3) {
						      this.getMenus(true, false);
						    } else {
						      this.getMenus(false, true);
						    }
					  } else if (this.verify === 3) {
						this.getMenus(false, false);
					  } else {
						this.getMenus(false, true);
					  }
				} else {
					this.getMenus(false);
				}
		     }
		},
		getMenus(pay, verify = true) {
			this.menus = this.list.filter(item => {
				if (item.title === '信息维护') {
					return verify && this.isVerify;
				} else if (item.title === '照片维护') {
					return this.isVerify;
				} else if (item.title === '网上缴费') {
					return pay && this.isPay;
				} else if (item.title === '申请退费') {
					return this.isRefund;
				} else if (item.title === '参考确认') {
					return this.isConfirm;
				} else if (item.title === '打印面试准考证') {
					return true;
				} else if (item.title === '成绩查询') {
					return this.isQuery;
				} else {
					return true;
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/color.scss';

.aside {
	box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.16);
	margin-right: 3px;

	.logo {
		padding: 0 20px;
		font-size: 18px;
		height: 60px;
		background: #fff;
		display: flex;
		align-items: center;
		letter-spacing: 2px;
		color: #000000;
	}

	> .el-menu {
		height: calc(100vh - 120px);
		overflow-x: hidden;
		overflow-y: auto;
		border-right: none;

		.el-submenu {
			position: relative;

			.left-bg {
				display: none;
			}

			&.is-active {
				::v-deep .el-submenu__title {
					color: $--color-primary !important;
					background-color: #e3ebfd !important;

					i {
						color: #fff;
					}
				}

				.left-bg {
					display: block;
					position: absolute;
					top: 0;
					left: 0;
					width: 5px;
					height: 100%;
					background: $--color-primary;
				}
			}

			.el-menu-item {
				span {
					padding-left: 9px;
				}
			}
		}

		.el-menu-item {
			line-height: 45px;
			height: 45px;

			&.is-active {
				color: $--color-primary !important;
				background-color: #e3ebfd !important;

				.left-bg {
					display: block;
					position: absolute;
					top: 0;
					left: 0;
					width: 5px;
					height: 100%;
					background: $--color-primary;
				}
			}

			span {
				padding-left: 9px;
			}
		}
	}
}
</style>
